export const getQueryParams = (queryParams: { [key: string]: string }) =>
  new URLSearchParams(queryParams).toString()
